import { FC, ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import styles from './AcknowledgmentBlockedBanner.module.scss'

export type AcknowledgmentBlockedAction = {
  /** The button's text, e.g. `Open Core Print`. */
  label: ReactNode
  onClick: () => void
}

type AcknowledgmentBlockedBannerProps = {
  /** The server's `AlertKey`: a translation key or a ready sentence. */
  reason: string
  action?: AcknowledgmentBlockedAction | null
}

/**
 * Why the server holds the plan's signatures, in the warning block the partner page has always
 * shown for it, with the way to what holds them where the host has one.
 */
export const AcknowledgmentBlockedBanner: FC<AcknowledgmentBlockedBannerProps> = ({
  reason,
  action,
}) => (
  <div className={styles.banner}>
    <i className={`${styles.icon} kbase kbase-warning-alt`} aria-hidden="true" />
    <span className={styles.text}>
      <Translation span text={reason} />
    </span>
    {action && (
      <Button className={styles.action} size="sm" color="warning" onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </div>
)
